export const Time = (time) => {
    var hour = Number(time.slice(0, 2));
    var amPm = hour >= 12 ? "pm" : "am";
    var formattedHour = hour % 12 || 12;
    var timeFormat = formattedHour + amPm;
    return timeFormat;
}